export const contestsFormDataBodySerializer = (data) => {
    var _a, _b;
    const formData = new FormData();
    (_a = data.contest) === null || _a === void 0 ? void 0 : _a.forEach((entry, i) => {
        var _a;
        if (entry.question) {
            formData.append(`contest[${i}][question]`, entry.question);
        }
        (_a = entry.answers) === null || _a === void 0 ? void 0 : _a.forEach((answer, j) => {
            formData.append(`contest[${i}][answers][${j}]`, answer);
        });
    });
    (_b = data.files) === null || _b === void 0 ? void 0 : _b.forEach((file, i) => {
        formData.append(`files[${i}]`, file);
    });
    return formData;
};
//# sourceMappingURL=contestsFormDataBodySerializer.js.map